/**
 * Returns true if the given value is an empty string; otherwise, false.
 *
 * Note that this is a type guard that narrows the type.
 *
 * @param {unknown} value - value to check
 * @returns {value is ""} - true if value is an empty string
 */
export default function isEmpty(value) {
  return value === "";
}
